export default __webpack_public_path__ + "c3ce74c9ef7c59f3d327d1392156f2e9.png";